// Те же границы, что и при регистрации (LoginForm).
const PASSWORD_MIN_LENGTH = 4;
const PASSWORD_MAX_LENGTH = 20;

export type PasswordField = "current" | "next" | "confirm";
export type PasswordValues = Record<PasswordField, string>;
export type PasswordErrors = Partial<Record<PasswordField, string>>;

const validateNewPassword = (next: string, current: string) => {
  if (next.length < PASSWORD_MIN_LENGTH || next.length > PASSWORD_MAX_LENGTH) {
    return `Password must be ${PASSWORD_MIN_LENGTH}–${PASSWORD_MAX_LENGTH} characters.`;
  }
  if (next === current) {
    return "New password must differ from the current one.";
  }
  return undefined;
};

export const validatePasswords = ({
  current,
  next,
  confirm,
}: PasswordValues): PasswordErrors => ({
  current: current ? undefined : "Enter your current password.",
  next: validateNewPassword(next, current),
  confirm: confirm === next ? undefined : "Passwords do not match.",
});

export const hasPasswordErrors = (errors: PasswordErrors): boolean =>
  Object.values(errors).some(Boolean);
